import { Controller } from "@hotwired/stimulus"
import Tags from "bootstrap5-tags";

// Connects to data-controller="task-tag"
export default class extends Controller {
  static targets = [ "element" ]
  connect() {
    Tags.init("#" + this.elementTarget.id, { allowClear: true });
  }
}
